/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostAIAssistantReceptionQRCodeRequestBodyTypename = "PostAIAssistantReceptionQRCodeRequestBody" as const;

/**
 *
 * @export
 * @interface PostAIAssistantReceptionQRCodeRequestBody
 */
export interface PostAIAssistantReceptionQRCodeRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  firstName: string;
  /**
   *
   * @type {number}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  genericDrugsCategory?: number;
  /**
   *
   * @type {number}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  insuranceCardCategory?: number;
  /**
   *
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  lastName: string;
  /**
   *
   * @type {number}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  medicalSubsidyCertificateCategory?: number;
  /**
   *
   * @type {number}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  medicationRecordCategory?: number;
  /**
   *
   * @type {number}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  specialMedicalCertificateCategory?: number;
  /**
   *
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  tel?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeRequestBody
   */
  readonly __typename?: string;
}

export function PostAIAssistantReceptionQRCodeRequestBodyFromJSON(
  json: any
): PostAIAssistantReceptionQRCodeRequestBody {
  return PostAIAssistantReceptionQRCodeRequestBodyFromJSONTyped(json, false);
}

export function PostAIAssistantReceptionQRCodeRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostAIAssistantReceptionQRCodeRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostAIAssistantReceptionQRCodeRequestBodyTypename,

    birthday: !exists(json, "birthday") ? undefined : json["birthday"],
    firstName: json["first_name"],
    genericDrugsCategory: !exists(json, "generic_drugs_category") ? undefined : json["generic_drugs_category"],
    insuranceCardCategory: !exists(json, "insurance_card_category") ? undefined : json["insurance_card_category"],
    lastName: json["last_name"],
    medicalSubsidyCertificateCategory: !exists(json, "medical_subsidy_certificate_category")
      ? undefined
      : json["medical_subsidy_certificate_category"],
    medicationRecordCategory: !exists(json, "medication_record_category")
      ? undefined
      : json["medication_record_category"],
    specialMedicalCertificateCategory: !exists(json, "special_medical_certificate_category")
      ? undefined
      : json["special_medical_certificate_category"],
    tel: !exists(json, "tel") ? undefined : json["tel"],
  };
}

export function PostAIAssistantReceptionQRCodeRequestBodyToJSON(
  object?: PostAIAssistantReceptionQRCodeRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    birthday: value.birthday,
    first_name: value.firstName,
    generic_drugs_category: value.genericDrugsCategory,
    insurance_card_category: value.insuranceCardCategory,
    last_name: value.lastName,
    medical_subsidy_certificate_category: value.medicalSubsidyCertificateCategory,
    medication_record_category: value.medicationRecordCategory,
    special_medical_certificate_category: value.specialMedicalCertificateCategory,
    tel: value.tel,
  };
}
